<div mat-dialog-content>
   <div class="spinner-Overlay" *ngIf="displaySpinner">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>  
   <div class="filter-modal-body">
      <!-- Section to display Title -->
      <div class="filter-modal-header">
         <h5 class="filter-modal-title pt-3">{{ "Casefilterdialog.FilterBy" | translate }}</h5>
         <h5 class="filter-modal-title-pt-3" (click) = "clearAll()">
           {{ "Casefilterdialog.ClearAll" | translate }}
       </h5>
      </div>
      <div class="hr-white"></div>
      <!-- Section to display anatomy Filter -->
      <div class="alignItems filter-list">
         <div>
            <p>{{ "Casefilterdialog.Anatomy" | translate }}</p>
         </div>
         <!-- Plus/Minus icons to show and hide filter -->
         <div class="pointer text-26" *ngIf="!showanatomy" (click)="toggle('anatomy')">
            <p>+</p>
         </div>
         <div class="pointer text-26" *ngIf="showanatomy" (click)="toggle('anatomy')">
            <p>-</p>
         </div>
      </div>
      <!-- Section to display list of anatomy -->
      <div *ngIf="showanatomy" class="item-list" id="">
         <span><button class="btn list-btn" [ngClass]="{ active: anatomy.isSelected === true }"
               *ngFor="let anatomy of anatomy; let i = index" (click)="onSelect(anatomy.anatomyId, 'anatomy')" [disabled] = "anatomy.isSelected">
               {{ anatomy.anatomyName | titlecase }}
               <img *ngIf = "anatomy.isSelected === true" (click)="onDeSelect(anatomy.anatomyId, 'anatomy');$event.stopPropagation();"  class= "closeBtn" src="assets\images\closeBtn.svg" alt=" {{ 'Casefilterdialog.Close' | translate }}"/>
            </button></span>
      </div>
      <div class="hr-white"></div>
      <!-- Section to display type Filter -->
      <div class="alignItems filter-list">
         <div>
            <p>{{ "Casefilterdialog.Type" | translate }}</p>
         </div>
         <div class="pointer text-26" *ngIf="!showtype" (click)="toggle('type')">
            <p>+</p>
         </div>
         <div class="pointer text-26" *ngIf="showtype" (click)="toggle('type')">
            <p>-</p>
         </div>
      </div>
      <!-- Section to display list of type -->
      <div *ngIf="showtype" class="item-list">
         <span><button class="btn list-btn" [ngClass]="{ active: type.isSelected === true }"
               *ngFor="let type of type; let i = index" (click)="onSelect(type.typeId, 'type')" [disabled] = "type.isSelected">
               {{ type.type }}
               <img *ngIf = "type.isSelected === true" (click)="onDeSelect(type.typeId, 'type');$event.stopPropagation();"  class= "closeBtn" src="assets\images\closeBtn.svg" alt=" {{ 'Casefilterdialog.Close' | translate }}"/>
            </button></span>
      </div>
      <div class="hr-white"></div>
      <!-- Section to display imagecenter Filter -->

      <div
         *ngIf="activeImgFlag"
         class="alignItems filter-list">
         <div>
            <p>{{"Casefilterdialog.ImageCenter" | translate}}</p>
         </div>
         <div class="pointer text-26" *ngIf="!showimagecenter" (click)="toggle('imagecenter')">
            <p>+</p>
         </div>
         <div class="pointer text-26" *ngIf="showimagecenter" (click)="toggle('imagecenter')">
            <p>-</p>
         </div>
      </div>
      <!-- Section to display list of imagecenter -->
      <div *ngIf="showimagecenter" class="item-list">

         <span>
            <div class="search_input">
               <input type="text" class="search" [(ngModel)]="searchTextImg" placeholder="{{'Casefilterdialog.Search' | translate}}">
               <button class="btn-SN-primary" (click)="searchImgCenter()" type="button">{{'Search' | translate}}</button>
            </div>
            <button class="btn list-btn" [ngClass]="{active : (imagecenter.isSelected === true)}"
               *ngFor="let imagecenter of imagecenter;let i = index;"
               (click)="onSelect(imagecenter.imagecenterId, 'imagecenter')" [disabled] = "imagecenter.isSelected">{{imagecenter.imagecenterName}}
               <img *ngIf = "imagecenter.isSelected === true" (click)="onDeSelect(imagecenter.imagecenterId, 'imagecenter');$event.stopPropagation();"  class= "closeBtn" src="assets\images\closeBtn.svg" alt=" {{ 'Casefilterdialog.Close' | translate }}"/>
            </button>
         </span>
      </div>
      <div *ngIf="activeImgFlag" class="hr-white"></div>
      <!-- Section to display File Status Filter -->
      <div class="alignItems filter-list">
         <div>
            <p>{{ "Casefilterdialog.Status" | translate }}</p>
         </div>
         <div class="pointer text-26" *ngIf="!showStatus" (click)="toggle('status')">
            <p>+</p>
         </div>
         <div class="pointer text-26" *ngIf="showStatus" (click)="toggle('status')">
            <p>-</p>
         </div>
      </div>
      <!-- Section to display list of File status -->
      <div *ngIf="showStatus" class="item-list">
         <span><button class="btn list-btn" [ngClass]="{ active: status.isSelected === true }"
               *ngFor="let status of status; let i = index" (click)="onSelect(status.statusId, 'status')" [disabled] = "status.isSelected">
               {{ status.status | titlecase}}
               <img *ngIf = "status.isSelected === true" (click)="onDeSelect(status.statusId, 'status');$event.stopPropagation();"  class= "closeBtn" src="assets\images\closeBtn.svg" alt=" {{ 'Casefilterdialog.Close' | translate }}"/>
            </button></span>
      </div>
      <div class="hr-white"></div>
      <!-- Section to display completeddate Filter -->

      <div
         *ngIf="completeDateFlag"
         class="alignItems filter-list">

         <div class="complete-date">
            <p>{{"Casefilterdialog.CompletedDate" | translate}}</p>
            <p class="clear-typography" (click)="clearCompletedDate()" *ngIf="selectedStart || selectedEnd">{{ "Casefilterdialog.Clear" | translate }}</p>
         </div>

         <div class="pointer text-26" *ngIf="!showcompleteddate" (click)="toggle('completeddate')">
            <p>+</p>
         </div>

         <div class="pointer text-26" *ngIf="showcompleteddate" (click)="toggle('completeddate')">
            <p>-</p>
         </div>

      </div>

      <!-- Section to display list of File completeddate -->
      <div *ngIf="showcompleteddate" class="item-date">
         <div class="d-flex">
            <button *ngIf="!selectedStart" class="btn filter-dates" (click)="toggle('startDate')">{{'Casefilterdialog.StartDate' | translate}}</button>
            <button *ngIf="selectedStart" class="btn active-date" (click)="toggle('startDate')">{{selectedStart | date :'MM/dd/yyyy'}}</button>
            <span *ngIf="selectedStart && selectedEnd" class="active-date mt-1" >-</span>
            <button *ngIf="!selectedEnd" class="btn filter-dates" (click)="toggle('endDate')">{{'Casefilterdialog.EndDate' | translate}}</button>
            <button *ngIf="selectedEnd" class="btn active-date" (click)="toggle('endDate')">{{selectedEnd | date : 'MM/dd/yyyy'}}</button> 
         </div>
         <div *ngIf="showStartDate && !showEndDate">
            <mat-card appearance="outlined" class="demo-inline-calendar-card">
               <mat-calendar [maxDate]="maxDate" [startAt]="selectedStart" [(selected)]="selectedStart"
                  (click)="dateChosen($event,'startDate');onSelect(1,'duedate') ">
               </mat-calendar>
            </mat-card>
            </div>
         <div *ngIf="showEndDate && !showStartDate">
            <mat-card appearance="outlined" class="demo-inline-calendar-card">
               <mat-calendar [maxDate]="today" [startAt]="selectedEnd" [minDate]="minDate" [(selected)]="selectedEnd" 
               (click)="dateChosen($event,'endDate');onSelect(1,'endDate')"></mat-calendar>
            </mat-card>
            </div>
      </div>
      <div *ngIf="completeDateFlag" class="hr-white"></div>
      <!-- Section to display File assigned Filter -->
      <div *ngIf="activeHilFlag || caseHisFlag" class="alignItems filter-list">
         <div>
            <p>{{ "Casefilterdialog.Assigned" | translate }}</p>
         </div>
         <div class="pointer text-26" *ngIf="!showassigned" (click)="toggle('assigned')">
            <p>+</p>
         </div>
         <div class="pointer text-26" *ngIf="showassigned" (click)="toggle('assigned')">
            <p>-</p>
         </div>
      </div>
      <!-- Section to display list of File assigned -->
      <div *ngIf="showassigned" class="item-list">
         <span>
            <div class="search_input">
               <input type="text" class="search font-SN-book" [(ngModel)]="searchTextAssign" placeholder="{{'Casefilterdialog.Search' | translate}}" />
               <button class="btn-SN-primary" (click)="searchAssignedTo()" type="button">{{ "Casefilterdialog.Search" | translate }}</button>
            </div>
            <button class="btn list-btn" [ngClass]="{ active: assigned.isSelected === true }"
               *ngFor="let assigned of assigned; let i = index" (click)="onSelect(assigned.assignedId, 'assigned')" [disabled] = "assigned.isSelected" >
               {{ assigned.assignedName }}
                  <img *ngIf = "assigned.isSelected === true" (click)="onDeSelect(assigned.assignedId, 'assigned');$event.stopPropagation();"  class= "closeBtn" src="assets\images\closeBtn.svg" alt=" {{ 'Casefilterdialog.Close' | translate }}"/>
            </button>
         </span>
      </div>
      <div *ngIf="activeHilFlag || caseHisFlag" class="hr-white"></div>
      <!-- Section to display duedate Filter -->
      <div class="alignItems filter-list">
         <div class="due-date">
            <p>{{"Casefilterdialog.DueDate" | translate}}</p>
            <p class="clear-typography" (click)="clearDueDate()" *ngIf="selectedStartDueDate || selectedEndDueDate">{{ "Casefilterdialog.Clear" | translate }}</p>
         </div>
         <div class="pointer text-26" *ngIf="!showduedate" (click)="toggle('duedate')">
            <p>+</p>
         </div>
         <div class="pointer text-26" *ngIf="showduedate" (click)="toggle('duedate')">
            <p>-</p>
          </div>
      </div>    
      <!-- Section to display list of File duedate -->
      <div *ngIf="showduedate" class="item-date">
          <div class="d-flex">
            <button *ngIf="!selectedStartDueDate" class="btn filter-dates" (click)="toggle('startDateDue')">{{'Casefilterdialog.StartDate' | translate}}</button>
            <button *ngIf="selectedStartDueDate" class="btn active-date" (click)="toggle('startDateDue')">{{selectedStartDueDate | date :
               'MM/dd/yyyy'}}</button>
            <span *ngIf="selectedStartDueDate && selectedEndDueDate" class="active-date mt-1" >-</span>
            <button *ngIf="!selectedEndDueDate" class="btn filter-dates" (click)="toggle('endDateDue')">{{'Casefilterdialog.EndDate' | translate}}</button>
            <button *ngIf="selectedEndDueDate" class="btn active-date" (click)="toggle('endDateDue')">{{selectedEndDueDate | date : 'MM/dd/yyyy'}}</button>   
         </div>
         <div *ngIf="showStartDateDue && !showEndDateDue">
         <mat-card appearance="outlined" class="demo-inline-calendar-card">
            <mat-calendar [startAt]="selectedStartDueDate" [(selected)]="selectedStartDueDate"
               (click)="dateChosen($event,'startDateDue');onSelect(1,'startDateDue') ">
            </mat-calendar>
         </mat-card>
         </div>
         <div *ngIf="showEndDateDue && !showStartDateDue">
            <mat-card appearance="outlined" class="demo-inline-calendar-card">
              <mat-calendar [startAt]="selectedEndDueDate" [minDate]="minDateDue" [(selected)]="selectedEndDueDate" 
              (click)="dateChosen($event,'endDateDue');onSelect(1,'endDateDue')"></mat-calendar>
            </mat-card>
          </div>
      </div>
      <div class="hr-white"></div>
      <!-- Section to display Done button -->
      <div class="filter-modal-footer">
         <button class="btn filter-btn-done" (click)="onSubmit()">
            {{ "Casefilterdialog.Done" | translate }}
         </button>
      </div>
   </div>
